import React, { FC } from "react"

import { Stack, ToggleButton, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"

import { TabNameTypes } from "./Teachers"

interface TeachersTabsProps {
  tabName: TabNameTypes
  onTabChange: (event: React.MouseEvent<HTMLElement>, newAlignment: TabNameTypes) => void
}

const TeachersTabs: FC<TeachersTabsProps> = ({ tabName, onTabChange }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Stack flexDirection="row" columnGap={1}>
      <ToggleButton
        value="active"
        selected={tabName === "active"}
        sx={{
          color:
            tabName === "active"
              ? theme.palette.mockup.primary60
              : theme.palette.mockup.neutral10,
          borderRadius: "8px 8px 0 0",
          borderBottom: "none",
          borderColor: theme.palette.mockup.neutral40,
          backgroundColor:
            tabName === "active"
              ? theme.palette.common.white
              : theme.palette.mockup.primary95,
          width: "110px",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
        onClick={(e) => onTabChange(e, "active")}
      >
        {t("adminDashboard.active")}
      </ToggleButton>
      <ToggleButton
        onClick={(e) => onTabChange(e, "pending")}
        value="pending"
        selected={tabName === "pending"}
        sx={{
          color:
            tabName === "pending"
              ? theme.palette.mockup.primary60
              : theme.palette.mockup.neutral10,
          borderRadius: "8px 8px 0 0",
          borderBottom: "none",
          borderColor: theme.palette.mockup.neutral40,
          backgroundColor:
            tabName === "pending"
              ? theme.palette.common.white
              : theme.palette.mockup.primary95,
          width: "110px",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        {t("adminDashboard.pending")}
      </ToggleButton>
    </Stack>
  )
}

export default TeachersTabs
